import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Blockchainplatforms() {
  return (
    <section className="blockchain_platforms p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Blockchain Development <span>Platforms We Specialize In</span>
            </h2>
            <p>
              Learn about the Ethereum application development services offered
              to launch innovative blockchain solutions. From a highly focused
              and advanced platform like Ethereum to a relatively new technology
              like Polkadot, our expert blockchain developers are masters at
              working on the appropriate platform in line with your business
              needs.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="block_platforms_main">
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_1.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={37}
                    height={60}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_2.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={57}
                    height={53}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_3.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={107}
                    height={33}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_4.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={53}
                    height={53}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_5.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={44}
                    height={63}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_6.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={64}
                    height={54}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_7.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={56}
                    height={65}
                  />
                </div>
              </div>
              <div className="block_platforms_item">
                <div className="block_platforms_img">
                  <StaticImage
                    src="../../images/services-usa/blockchain-new/platform_8.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={65}
                    height={65}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Blockchainplatforms;
